import { MutationCache, QueryCache, QueryClient } from '@tanstack/react-query';
import { notifications } from '@mantine/notifications';
import { isHTTPError } from 'ky';

import { ONE_SECOND } from './utils/time';

function logDetailedError(error: Error, context: string) {
  console.group(`🔴 ${context} Error`);
  console.error('Error Name:', error.name);
  console.error('Error Message:', error.message);
  console.error('Full Error:', error);
  console.groupEnd();
}

function getErrorMessage(error: Error): string {
  if (isHTTPError(error)) {
    const status = error.response.status;
    if (status === 403) return 'Accès refusé.';
    if (status === 404) return 'Ressource introuvable.';
    if (status === 422 || status === 400) return error.message || 'Données invalides.';
    if (status >= 500) return 'Erreur serveur. Veuillez réessayer.';
  }
  return error.message || 'Une erreur est survenue.';
}

//todo : decide whether to keep logging in production, silence it, or send it via sentry or equivalent.
export const queryClient = new QueryClient({
  queryCache: new QueryCache({
    onError(error) {
      logDetailedError(error, 'Query');
    },
  }),
  mutationCache: new MutationCache({
    onError(error, _variables, _context, mutation) {
      logDetailedError(error, 'Mutation');
      // Skip if the mutation has its own onError handler — it will handle the UX itself
      if (mutation.options.onError) return;
      notifications.show({
        color: 'red',
        title: 'Erreur',
        message: getErrorMessage(error),
        autoClose: 5000,
      });
    },
  }),
  defaultOptions: {
    queries: {
      retry: 1,
      // todo : change for deploy
      staleTime: ONE_SECOND * 1500,
      gcTime: ONE_SECOND * 3000,
      refetchInterval: ONE_SECOND * 1500,
    },
  },
});
